var React = require('react');

function ArrowInCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"23.5","stroke":"#055064","key":0}),React.createElement("path",{"d":"M17.5 24H30M30 24L24 18M30 24L24 30","stroke":"#055064","key":1})]);
}

ArrowInCircle.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ArrowInCircle;

ArrowInCircle.default = ArrowInCircle;
